export var TAG_COLORS = {
    LIGHT_YELLOW: 0,
    LIGHT_ORANGE: 0,
    LIGHT_RED: 0,
    LIGHT_PINK: 0,
    LIGHT_PURPLE: 0,
    LIGHT_BLUE: 0,
    LIGHT_GREEN: 0,
};
